export default {
  CHANGE_DISPLAYED_PANEL: 'change_displayed_panel',
  BASE_PANEL: 'base_panel',
  FEEDBACK_PANEL: 'feedback_panel',
  THANKS_PANEL: 'thanks_panel',
  SEND_FEEDBACK: 'send_feedback',
};
